import React from 'react';
import { VideoItemProps } from './type';
import { ImageComponent } from './ImageComponent';
import { VideoComponent } from './VideoComponent';

export const EscalatorItem = (props: VideoItemProps) => {
    const { url } = props;
    const isImage = url && url.match(/\.(jpeg|jpg|gif|png|webp|avif)(\?.*)?$/i);

    if (isImage) {
        return <ImageComponent url={props.url} width={props.width} height={props.height} />;
    }

    return <VideoComponent {...props} />;
};
